import React, { useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { Box, Flex, Stack, xcss } from '@atlaskit/primitives';
import { DataClassificationDropdown } from '../../common/ui/data-classification-dropdown';
import { messages } from '../../messages';
const popupContainerStyles = xcss({
  width: '330px',
  padding: 'space.250'
});
export const EditPopup = ({
  options,
  selectedOption,
  customHeading = undefined,
  loading = false,
  errorMessage,
  onEditCancel,
  onEditSubmit,
  onChange
}) => {
  const intl = useIntl();

  // This keeps track of the selected classification in the dropdown. selectedOption is the classification that was selected before the edit popup was opened.
  const [selectedClassification, setSelectedClassification] = useState(selectedOption);
  const onDropdownChange = selected => {
    setSelectedClassification(selected);
  };
  const onUpdateClick = () => {
    selectedClassification && onEditSubmit && onEditSubmit(selectedClassification);
  };
  return /*#__PURE__*/React.createElement(Box, {
    xcss: popupContainerStyles,
    role: "dialog",
    "aria-labelledby": "data-classification-edit-content-label",
    "aria-modal": "true"
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.200"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "h500",
    id: "data-classification-edit-content-label"
  }, customHeading || intl.formatMessage(messages.classifyContent)), /*#__PURE__*/React.createElement(DataClassificationDropdown, {
    label: intl.formatMessage(messages.selectClassification),
    options: options,
    value: selectedClassification,
    onChange: onDropdownChange,
    onInputChange: onChange,
    errorMessage: errorMessage
  }), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "end",
    gap: "space.050"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onEditCancel,
    appearance: "subtle"
  }, intl.formatMessage(messages.cancelButton)), /*#__PURE__*/React.createElement(Button, {
    isLoading: loading,
    onClick: onUpdateClick,
    appearance: "primary",
    isDisabled: !selectedClassification || Boolean(errorMessage)
  }, intl.formatMessage(messages.updateButton)))));
};